import { AxiosInstance } from "axios";
import authHeader from "./auth_header";
import axiosInstance from "./axios_instance";

const ApiPath = "/api/orderer";

class OrderService {
  private instance: AxiosInstance;
  private readonly navigate: any;

  constructor(navigate: any) {
    this.instance = axiosInstance(navigate);
    this.navigate = navigate;
  }

  async getOrdererInfo() {
    const headers = authHeader(this.navigate);
    return await this.instance.get(ApiPath, { headers });
  }
}

export default OrderService;
